export default "__VITE_ASSET__BqEEyn8m__"